// src/i18n.js
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// подключение переводов
import ua from "./locales/ua/translation.json";
import en from "./locales/en/translation.json";
import de from "./locales/de/translation.json";
import pl from "./locales/pl/translation.json";
import tr from "./locales/tr/translation.json";
import ru from "./locales/ru/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ua: { translation: ua },
      en: { translation: en },
      de: { translation: de },
      pl: { translation: pl },
      tr: { translation: tr },
      ru: { translation: ru },
    },
    supportedLngs: ["ua", "en", "de", "pl", "tr", "ru"],
    nonExplicitSupportedLngs: true,
    lng: "ua",            // 🔥 основной язык — украинский
    fallbackLng: "ua",    // 🔥 если чего-то нет, тоже показываем ua
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupQuerystring: 'lang',
      lookupCookie: 'i18next',
      cookieMinutes: 60 * 24 * 30,
    },
  });

export default i18n;
